"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1130],{

/***/ 10965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83719);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var checkLocale = function checkLocale(path) {
  return path.includes("/offshore") ? path.split("/offshore")[1] : path.includes("/hk") ? path.split("/hk")[1] : path.includes("/sg") ? path.split("/sg")[1] : path.includes("/vn") && path.split("/vn")[1];
};

var Component = function Component(_ref) {
  var data = _ref.data;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(checkLocale(router.pathname)),
      activeIndex = _useState[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "shadow-bbc relative  hidden w-fit rounded-xl bg-white text-center lg:inline-block",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
        className: "whitespace-nowrap py-3 px-5",
        children: Array.isArray(data) && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", {
            className: "inline-block  ".concat(index < data.length - 1 ? "border-r-2" : ""),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              as: "a",
              variant: "ghost",
              href: item.uri,
              useRouter: true,
              btnTextColor: "".concat(activeIndex === item.uri ? "" : "text-bbc-neutral-700 hover:text-bbc-brand-600"),
              othersClass: "".concat(activeIndex === item.uri ? "" : "inline-block font-normal"),
              children: item.title
            })
          }, index);
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: "dropdown-default m-auto block lg:hidden",
      data: data,
      activeIndex: data.length > 0 && data.find(function (item) {
        return activeIndex === item.uri;
      }).title
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {})
};

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 31130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ economic_substance; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheckCircle.js
var FaCheckCircle = __webpack_require__(59699);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/hi/HiOutlineChevronRight.js

function HiOutlineChevronRight(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "2",
        "d": "M9 5l7 7-7 7"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/PageType/index.js
var PageType = __webpack_require__(10965);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/common/economic-substance/EconomicPricing/index.js




var Component = function Component(_ref) {
  var className = _ref.className,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        text: data.title,
        as: "h4",
        className: " mb-6 text-center text-3xl font-semibold text-bbc-brand-800 lg:mb-10 lg:text-4xl"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-12 lg:col-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "shadow-bbc mb-6 overflow-hidden rounded-2xl bg-white lg:mb-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "border-b border-[#E5E5E5] p-3 text-center font-medium text-bbc-brand-700",
                children: data.dataPrice1.title
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: data.dataPrice1.ListItem && data.dataPrice1.ListItem.length > 0 && data.dataPrice1.ListItem.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex px-4 py-3 odd:bg-white even:bg-bbc-brand-100",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "w-9/12 pr-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mb-1 text-sm font-medium text-bbc-gray",
                      dangerouslySetInnerHTML: {
                        __html: item.titleItem
                      }
                    }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-sm font-normal italic ",
                      style: {
                        color: "#7c7b7b"
                      },
                      dangerouslySetInnerHTML: {
                        __html: item.description
                      }
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "grow self-center text-sm text-bbc-brand-500",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      className: "text-right",
                      children: ["US$", item.price]
                    }), item.time && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-right",
                      children: item.time
                    })]
                  })]
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "shadow-bbc mb-6 overflow-hidden rounded-2xl bg-white lg:mb-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "border-b border-[#E5E5E5] p-3 text-center font-medium text-bbc-brand-700",
                children: data.dataPrice2.title
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: data.dataPrice2.ListItem && data.dataPrice2.ListItem.length > 0 && data.dataPrice2.ListItem.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex px-4 py-3 odd:bg-white even:bg-bbc-brand-100",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "w-9/12 pr-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      dangerouslySetInnerHTML: {
                        __html: item.titleItem
                      },
                      className: "mb-1 text-sm font-medium text-bbc-gray"
                    }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      dangerouslySetInnerHTML: {
                        __html: item.description
                      },
                      className: "text-sm font-normal italic ",
                      style: {
                        color: "#7c7b7b"
                      }
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "grow self-center text-sm text-bbc-brand-500",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      className: "text-right",
                      children: ["US$", item.price]
                    }), item.time && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-right",
                      children: item.time
                    })]
                  })]
                }, index);
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 lg:col-7",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "shadow-bbc overflow-hidden rounded-2xl bg-white",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "border-b border-[#E5E5E5] p-3 text-center font-medium text-bbc-brand-700",
                children: data.dataPrice3.title
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: data.dataPrice3.ListItem && data.dataPrice3.ListItem.length > 0 && data.dataPrice3.ListItem.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex px-4 py-3 odd:bg-white even:bg-bbc-brand-100",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "w-9/12 pr-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      dangerouslySetInnerHTML: {
                        __html: item.titleItem
                      },
                      className: "mb-1 text-sm font-medium text-bbc-gray"
                    }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      dangerouslySetInnerHTML: {
                        __html: item.description
                      },
                      className: "text-sm font-normal italic ",
                      style: {
                        color: "#7c7b7b"
                      }
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "grow self-center text-sm text-bbc-brand-500",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      className: "text-right",
                      children: ["US$", item.price]
                    }), item.time && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-right",
                      children: item.time
                    })]
                  })]
                }, index);
              })
            })]
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var EconomicPricing = (Component);
Component.defaultProps = {
  className: ""
};
;// CONCATENATED MODULE: ./components/templates/common/economic-substance/index.js


















var NewsSlider = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(1290)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/common/economic-substance/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var TableRow = function TableRow(_ref) {
  var childrenLeft = _ref.childrenLeft,
      childrenMiddle = _ref.childrenMiddle,
      childrenRight = _ref.childrenRight,
      isHeader = _ref.isHeader,
      index = _ref.index,
      hidden = _ref.hidden,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row ".concat(isHeader && "border-b ", " ").concat((index + 1) % 2 == 1 ? "bg-[#F7FDFF]" : "bg-white"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-4 p-3 font-medium text-bbc-brand-600 lg:col-2 lg:block lg:p-6 lg:pl-10",
      children: childrenLeft
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-8 p-4 text-lg lg:col-5 lg:p-6 ".concat(isHeader ? "text-center font-medium text-bbc-brand-600 lg:font-semibold" : "text-left", "\n          ").concat(hidden ? "hidden" : "block", "  \n         lg:block "),
      children: isHeader ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "align-middle",
          children: childrenMiddle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(HiOutlineChevronRight, {
          size: 32,
          onClick: onClick,
          className: "pointer-events float-right inline-block cursor-pointer rounded-full bg-bbc-brand-100 p-2 align-middle shadow-[0px_2px_4px_rgba(134,134,134,0.16)] lg:hidden"
        })]
      }) : childrenMiddle.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-2 flex items-start first:mt-0",
          children: [!item.match(/none/i) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
              size: 16,
              className: "mr-2 mt-1 text-bbc-brand-600"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: item
            },
            className: "text-sm leading-6 lg:text-base"
          })]
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-8 p-4 text-lg lg:col-5 lg:p-6 ".concat(isHeader ? "text-center font-semibold text-bbc-gray" : "text-left", " ").concat(hidden ? "block" : "hidden", " lg:block"),
      children: isHeader ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiOutlineChevronRight, {
          size: 32,
          onClick: onClick,
          className: "pointer-events float-left inline-block rotate-180 transform cursor-pointer rounded-full bg-bbc-brand-100 p-2 align-middle text-bbc-brand-700 shadow-[0px_-2px_4px_rgba(134,134,134,0.16)] lg:hidden"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "align-middle",
          children: childrenRight
        })]
      }) : childrenRight.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-2 flex items-start first:mt-0",
          children: [!item.match(/none/i) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
              size: 16,
              className: "mr-2 mt-1 text-bbc-brand-600"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: item
            },
            className: "text-sm leading-6 lg:text-base"
          })]
        }, index);
      })
    })]
  });
};

var EconomicSubstance = function EconomicSubstance(_ref2) {
  var data = _ref2.data,
      dataJson = _ref2.dataJson;
  var country = dataJson.country,
      breadcrumbs = dataJson.breadcrumbs,
      dataPageType = dataJson.dataPageType,
      dataTable = dataJson.dataTable,
      dataEconomicSubstance = dataJson.dataEconomicSubstance;

  var _useState = (0,react.useState)(false),
      hidden = _useState[0],
      setHidden = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      breadcrumbs: breadcrumbs,
      title: "".concat(country, "<br/> Economic Substance Requirements"),
      titleProps: {
        className: "banner-default-title mb-6 lg:mb-10",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        wrapper: {
          className: "bbc-banner-image-country pb-[98px] lg:pb-0"
        },
        src: "/assets/images/common/economic-subtance-banner.png",
        className: "w-full ",
        width: 541,
        height: 433,
        priority: true,
        alt: dataJson.imgAlt
      }),
      bgColor: "bg-bbc-country"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute left-1/2 -translate-x-1/2 -translate-y-[74px] text-center lg:-translate-y-1/2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageType/* default */.Z, {
        data: dataPageType,
        activeIndex: dataPageType[2].title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 md:mt-14",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "i flex flex-col justify-center lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "text-center lg:text-left",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                text: dataEconomicSubstance.title,
                className: "bbc-title mb-6"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-6",
                dangerouslySetInnerHTML: {
                  __html: dataEconomicSubstance.description
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                othersClass: "mb-6",
                onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return Tawk_API.toggle();

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })),
                children: "Talk To Our Expert Now"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                as: "a",
                useRouter: true,
                variant: "ghost",
                btnDisplay: "block",
                othersClass: "w-fit px-0 py-0 font-medium mx-auto lg:m-0",
                href: "/guide-and-tool/es-tool",
                children: "Try our ES self-assessment tool"
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid place-items-center lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: dataEconomicSubstance.src,
              width: 540,
              height: 540,
              alt: "Image Economic Substance",
              className: "w-full"
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [dataJson.dataPricing && typeof dataJson.dataPricing === "object" && Object.keys(dataJson.dataPricing).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(EconomicPricing, {
        data: dataJson.dataPricing,
        className: "mb-7 lg:mb-10"
      }), dataTable && Array.isArray(dataTable) && dataTable.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "".concat(country, " Economic Substance Test"),
          className: "bbc-title mb-6 text-center lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "shadow-bbc container mb-10 overflow-hidden rounded-xl",
          children: dataJson.dataTable.map(function (item, index) {
            if (index === 0) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TableRow, {
                childrenLeft: item.left,
                childrenMiddle: item.middle,
                childrenRight: item.right,
                isHeader: true,
                hidden: hidden,
                onClick: function onClick() {
                  setHidden(!hidden);
                }
              }, index);
            }

            return /*#__PURE__*/(0,jsx_runtime.jsx)(TableRow, {
              index: index,
              childrenLeft: item.left,
              childrenMiddle: item.middle,
              childrenRight: item.right,
              hidden: hidden
            }, index);
          })
        })]
      }), country === "Belize" && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: "px-4 text-center",
        children: ["Need more details on how to file your ", country, " annual tax return?", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Check out this", /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
          href: "/news/belize-annual-tax-return",
          className: "font-medium text-bbc-brand-500",
          children: [" ", "quick guide", " "]
        }), "now >>"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:m-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var economic_substance = (EconomicSubstance);

/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

}]);